(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oc-purchase-upgrade"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-oc-mobile-purchase]');
    if (!bar || bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';

    const stickyId = bar.querySelector('[data-oc-variant-id]');
    const variantLabel = bar.querySelector('[data-oc-variant]');
    const priceLabel = bar.querySelector('[data-oc-price]');
    const button = bar.querySelector('button[type="submit"]');
    const variantsNode = bar.querySelector('[data-oc-variants]');
    const sourceForm = document.querySelector('product-form.main-product-form form');
    if (!stickyId || !variantsNode || !sourceForm) return;

    const variants = JSON.parse(variantsNode.textContent);
    const currency = document.documentElement.dataset.currency || 'USD';
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency
    });

    const sync = () => {
      const sourceId = sourceForm.querySelector('input[name="id"]');
      if (!sourceId) return;
      stickyId.value = sourceId.value;
      const variant = variants.find((item) => String(item.id) === String(sourceId.value));
      if (!variant) return;

      const title = variant.title === 'Default Title' ? '' : `${variant.title} · `;
      variantLabel.firstChild.textContent = title;
      priceLabel.textContent = formatter.format(variant.price / 100);
      button.disabled = !variant.available;
    };

    document.addEventListener('change', () => requestAnimationFrame(sync));
    document.addEventListener('variant:change', sync);
    new MutationObserver(sync).observe(sourceForm, {
      attributes: true,
      childList: true,
      subtree: true
    });
    sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
